import {observer} from "mobx-react";
import Grid from "@mui/material/Unstable_Grid2";
import React from "react";
import {Button, Divider, Typography} from "@mui/material";
import {useStore} from "../../../stores/Store";
import BrandFilter from "./BrandFilter";
import BassTypeFilter from "./BassTypeFilter";
import RightHandSystemFilter from "./RightHandSystemFilter";
import WeightFilter from "./WeightFilter";
import HeightFilter from "./HeightFilter";
import WidthFilter from "./WidthFilter";
import RightButtonRowsFilter from "./RightButtonRowsFilter";
import RightButtonsFilter from "./NotesRightButtonFilter";
import ChorusRightFilter from "./ChorusRightFilter";
import CassottoRightFilter from "./CassottoRightFilter";
import RegisterRightFilter from "./RegisterRightFilter";
import ChinSwitchesFilter from "./ChinSwitchesFilter";
import RowsBtnLeftFilter from "./RowsBtnLeftFilter";
import StandardBassFilter from "./StandardBassFilter";
import StandardBassChorusFilter from "./ChorusSbFilter";
import RegisterSbFilter from "./RegisterSbFilter";
import FreeBassNotesFilter from "./FreeBassNotesFilter";
import RegisterFbFilter from "./RegisterFbFilter";
import ChorusFbFilter from "./ChorusFbFilter";
import NotesRightPianoFilter from "./NotesRightPianoFilter";
import {RightHandSystem} from "../../../models/RightHandSystem";
import ReedsFilter from "./ReedsFilter";
import UsedFilter from "./UsedFilter";
import {EntityStatus} from "../../../models/EntityStatus";

export default observer(function AccordionsFilter(){
    const {LanguageStore, AccordionStore} = useStore();
    const { currentLanguageMessages } = LanguageStore;
    const {resetFilter, filteredRightSystem, mode, accordions} = AccordionStore;


    return (
        <Grid container justifyContent={'center'} spacing={4}>
            <Grid xs={12}>
                <Button
                    color={'secondary'}
                    onClick={resetFilter}
                    variant={"contained"}
                >
                    { currentLanguageMessages.AccordionsPage.Filter.resetFilterBtnLabel }
                </Button>
            </Grid>
            <Grid xs={12}>
                <Typography>{currentLanguageMessages.AccordionsPage.Filter.generalCategoryTitle}</Typography>
                <Divider />
            </Grid>
            <Grid xs={12}>
                <BrandFilter />
            </Grid>
            {
                mode === 'rent' ||
                accordions.filter(a => !a.rental && a.used && a.status === EntityStatus.created).length === 0 ?
                    null :
                    <Grid xs={12}>
                        <UsedFilter />
                    </Grid>
            }
            <Grid xs={12}>
                <BassTypeFilter />
            </Grid>
            <Grid xs={12}>
                <Typography>{currentLanguageMessages.AccordionsPage.Filter.rightHandCategoryTitle}</Typography>
                <Divider />
            </Grid>
            <Grid xs={12}>
                <RightHandSystemFilter />
            </Grid>
            {(filteredRightSystem === RightHandSystem.Button) ? null :
                <Grid xs={12}>
                    <NotesRightPianoFilter />
                </Grid>
            }
            {
                (filteredRightSystem === RightHandSystem.Piano) ? null :
                    <Grid xs={12}>
                        <RightButtonsFilter />
                    </Grid>
            }
            {
                (filteredRightSystem === RightHandSystem.Piano) ? null :
                    <Grid xs={12}>
                        <RightButtonRowsFilter />
                    </Grid>
            }
            <Grid xs={12}>
                <ChorusRightFilter />
            </Grid>
            <Grid xs={12}>
                <CassottoRightFilter />
            </Grid>
            <Grid xs={12}>
                <RegisterRightFilter />
            </Grid>
            <Grid xs={12}>
                <ChinSwitchesFilter />
            </Grid>
            <Grid xs={12}>
                <Typography>{currentLanguageMessages.AccordionsPage.Filter.leftHandCategoryTitle}</Typography>
                <Divider />
            </Grid>
            <Grid xs={12}>
                <RowsBtnLeftFilter />
            </Grid>
            <Grid xs={12}>
                <Typography>{currentLanguageMessages.AccordionsPage.Filter.standardBassCategoryTitle}</Typography>
                <Divider />
            </Grid>
            <Grid xs={12}>
                <StandardBassFilter />
            </Grid>
            <Grid xs={12}>
                <StandardBassChorusFilter />
            </Grid>
            <Grid xs={12}>
                <RegisterSbFilter />
            </Grid>
            <Grid xs={12}>
                <Typography>{currentLanguageMessages.AccordionsPage.Filter.freeBassCategoryTitle}</Typography>
                <Divider />
            </Grid>
            <Grid xs={12}>
                <FreeBassNotesFilter />
            </Grid>
            <Grid xs={12}>
                <RegisterFbFilter />
            </Grid>
            <Grid xs={12}>
                <ChorusFbFilter />
            </Grid>
            <Grid xs={12}>
                <Typography>{currentLanguageMessages.AccordionsPage.Filter.characteristicsCategoryTitle}</Typography>
                <Divider />
            </Grid>
            <Grid xs={12}>
                <ReedsFilter />
            </Grid>
            <Grid xs={12}>
                <HeightFilter />
            </Grid>
            <Grid xs={12}>
                <WidthFilter />
            </Grid>
            <Grid xs={12}>
                <WeightFilter />
            </Grid>
        </Grid>
    )
})